<div class='panel panel-primary'>
  <div #popBox style="position:absolute;width:1px;height:1px;">
    <!--<ng-template #popTitle let-language="language"></ng-template>-->
    <ng-template #popContent let-greeting="greeting">
      <div class="clearfix input-section memberPop">
        <div class="section-45 profile-info">
          <div class="clearfix">
            <div class="profile-pic fl s2">
              <img [src]="profileImageUrl" alt="profile" />
            </div>
          </div>
          <div class="clearfix">
            <div class="title"> <b> {{popMember.Salutation}} {{popMember.FirstName}} {{popMember.LastName}} </b> </div>
          </div>
          <div class="clearfix">
            <span class="fieldname">Reg ID:</span> <span class="fieldvalue"> {{popMember.IdentityId}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">User Name: </span> <span class="fieldvalue"> {{popMember.UserName}}</span>
          </div>


        </div>
        <div class="section-50 profile-info">
          <div class="clearfix">
            <span class="fieldname">Active:</span> <span class="fieldvalue"><mat-checkbox [disabled]="true" [(ngModel)]="popMember.IsActive"></mat-checkbox> </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Start:</span> <span class="fieldvalue"> {{popMember.MembershipStartDate?.toLocaleDateString('en-GB')}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">End:</span> <span class="fieldvalue"> {{popMember.MembershipExpiryDate?.toLocaleDateString('en-GB')}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Date of Birth: </span> <span class="fieldvalue"> {{popMember.DateOfBirth?.toLocaleDateString('en-GB')}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Trainer: </span> <span class="fieldvalue"> {{popMember.AssignedTrainer?.FirstName}} {{popMember.AssignedTrainer?.LastName}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Referred By:</span> <span class="fieldvalue"> {{popMember.ReferredBy?.FirstName}} {{popMember.ReferredBy?.LastName}} </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Enrolled By:</span> <span class="fieldvalue">{{popMember.EnrolledBy?.FirstName}} {{popMember.EnrolledBy?.LastName}} </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Occupation:</span> <span class="fieldvalue">{{popMember.Occupation}} </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Contact:</span> <span class="fieldvalue"> {{popMember.Contact1}} {{popMember.Contact2 ?"/ "+popMember.Contact2 : ""}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Email:</span> <span class="fieldvalue"> {{popMember.Email}}</span>
          </div>
        </div>
      </div>

    </ng-template>
    <div class="btnPopoverTrigger"
         [ngbPopover]="popContent"
         popoverTitle=""
         [autoClose]="true"
         ngbPopover=""
         popoverClass="popOverride"
         #memberInfoPop="ngbPopover" placement="auto">
    </div> <!--[popoverTitle]="popTitle"-->
  </div>

  <div class="alert alert-info" role="alert" *ngIf="indLoading"><img src="../../assets/images/loader2.gif" width="32" height="32" /> Loading...</div>
  <div class="filter-controls">
    <!--<input type="text" class="form-control search-box" [value]="filter" (input)="filter = $event.target.value" (keyup.enter)="filterChange();" placeholder="Filter">-->
    <div class="form-control search-box">
      <span class="labelname padding-ls"> Balance:</span> <span class="labelvalue padding-ls" style="border-right: 2px solid #595959; padding-right: 10px;">{{AmountCollections?.BALANCE??0}}</span>
      <span class="labelvalue padding-ls">Collection - </span>
      <span class="labelname padding-ls"> Total:</span> <span class="labelvalue padding-ls">{{(AmountCollections?.CASH??0)+(AmountCollections?.CARD??0)+(AmountCollections?.ONLINE??0)+(AmountCollections?.CHEQUE??0)+(AmountCollections?.NONE??0)}}</span>
      <span class="labelname padding-ls"> Cash:</span> <span class="labelvalue padding-ls">{{AmountCollections?.CASH??0}}</span>
      <span class="labelname padding-ls"> Card:</span> <span class="labelvalue padding-ls">{{AmountCollections?.CARD??0}}</span>
      <span class="labelname padding-ls"> Online:</span> <span class="labelvalue padding-ls">{{AmountCollections?.ONLINE??0}}</span>
      <span class="labelname padding-ls"> Cheque:</span> <span class="labelvalue padding-ls">{{AmountCollections?.CHEQUE??0}}</span>
      <span class="labelname padding-ls"> Others:</span> <span class="labelvalue padding-ls">{{AmountCollections?.NONE??0}}</span>

      <div class="fl" style="border-right: 2px solid #595959; padding-right: 14px; font-size: 13px; font-weight: bold;">
        <mat-checkbox class="fl labelname"
                      color="accent"
                      (change)="filterData($event.checked)" #chkCanEdit>
          Only Balance
        </mat-checkbox>
      </div>

    </div>
    <div class="fl">
      <mat-form-field class="form-element field-l textfield-mr2">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="startpicker" [(ngModel)]="fromDate">
        <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
        <mat-datepicker #startpicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="form-element field-l textfield-mr2">
        <mat-label>To Date</mat-label>
        <input matInput [matDatepicker]="endpicker" [(ngModel)]="toDate">
        <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
        <mat-datepicker #endpicker></mat-datepicker>
      </mat-form-field>
      <input type="button" class="fl filterBtn" value="View" (click)="getCollectionData()" />
    </div>
  </div>
  <jqxGrid #dataGrid [theme]="'material-purple'" (onSort)="dataGridOnSort($event)" (onPagesizechanged)="onPageSizeChanged($event)"
           [width]="'99.8%'" [source]="dataAdapter" [columns]="columns"
           [pageable]="true" [sortable]="true" [editable]="false"
           [autoheight]="true" [enabletooltips]="true" [pagermode]="'default'"
           [virtualmode]="true" [rendergridrows]="rendergridrows" [pagesizeoptions]="['10','20','50']" (onBindingcomplete)="Bindingcomplete($event)">
  </jqxGrid>


</div>

